import { PaginationQuery } from "@/shared/sort/pagination-query.interface";

export default function buildPaginationQueryOpts(paginationQuery: PaginationQuery) {
  if (paginationQuery) {
    let parameters = [];
    if (paginationQuery.sort) {
      for (const idx of Object.keys(paginationQuery.sort)) {
        parameters.push(`sort=${idx},${paginationQuery.sort[idx]}`);
      }
    }
    if (paginationQuery.page) {
      parameters.push(`page=${paginationQuery.page}`);
    }
    if (paginationQuery.size) {
      parameters.push(`size=${paginationQuery.size}`);
    }
    if (paginationQuery.filter) {
      for (const [key, value] of Object.entries(paginationQuery.filter)) {
        const escapedValue = encodeURIComponent(value);
        parameters.push(`${key}=${escapedValue}`);
      }
    }

    if (!parameters.length) {
      return "";
    }
    return `${parameters.join("&")}`;
  }
  return "";
}
